import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/my_payroll/pages/RootPage'))
const MyPayrollPage = React.lazy(() => import('modules/my_payroll/pages/MyPayrollPage'))

export const myPayrollRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.myPayroll.path,

    element: <RootPage />,
    children: [
      {
        path: '',
        handle: {
          meta: () => ({
            title: i18n.t('my_payroll.title'),
          }),
        },
        element: <MyPayrollPage />,
      },
    ],
  },
]
